import React from 'react'
import Autocomplete from 'react-autocomplete'
import PropTypes from 'prop-types'

const WrappedAutocomplete = ({ onFocus, onBlur, className, ...rest }) => { // Need to pass down className for styled-components
  return <Autocomplete {...rest} inputProps={{ className, onFocus, onBlur }} />
}

WrappedAutocomplete.propTypes = {
  className: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
}

export default WrappedAutocomplete
